/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Faq_5_QInputs */

const en_landing_faq_5_q = /** @type {(inputs: Landing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How are applications submitted?`)
};

const de_landing_faq_5_q = /** @type {(inputs: Landing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie werden Bewerbungen eingereicht?`)
};

const fr_landing_faq_5_q = /** @type {(inputs: Landing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment les candidatures sont-elles soumises ?`)
};

const es_landing_faq_5_q = /** @type {(inputs: Landing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se envían las solicitudes?`)
};

const it_landing_faq_5_q = /** @type {(inputs: Landing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come vengono inviate le candidature?`)
};

const nl_landing_faq_5_q = /** @type {(inputs: Landing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe worden sollicitaties ingediend?`)
};

const pl_landing_faq_5_q = /** @type {(inputs: Landing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jak wysyłane są aplikacje?`)
};

const fi_landing_faq_5_q = /** @type {(inputs: Landing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Miten hakemukset lähetetään?`)
};

const da_landing_faq_5_q = /** @type {(inputs: Landing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvordan indsendes ansøgninger?`)
};

const sv_landing_faq_5_q = /** @type {(inputs: Landing_Faq_5_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hur skickas ansökningar in?`)
};

/**
* | output |
* | --- |
* | "How are applications submitted?" |
*
* @param {Landing_Faq_5_QInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const landing_faq_5_q = /** @type {((inputs?: Landing_Faq_5_QInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Faq_5_QInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_landing_faq_5_q(inputs)
	if (locale === "fr") return fr_landing_faq_5_q(inputs)
	if (locale === "es") return es_landing_faq_5_q(inputs)
	if (locale === "it") return it_landing_faq_5_q(inputs)
	if (locale === "nl") return nl_landing_faq_5_q(inputs)
	if (locale === "pl") return pl_landing_faq_5_q(inputs)
	if (locale === "fi") return fi_landing_faq_5_q(inputs)
	if (locale === "da") return da_landing_faq_5_q(inputs)
	if (locale === "sv") return sv_landing_faq_5_q(inputs)
	return en_landing_faq_5_q(inputs)
});